import axios from "axios";

import { getConfig } from "@/config";

/** The marketing admin read VITE_* origins in its old repo; inside the dashboard the admin config owns them. */
const config = getConfig();

export const apiClient = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "Content-Type": "application/json",
    "X-API-KEY": config.apiKey,
  },
});

// Community admin lives on the internal-api host (migrated out of the external apps/api).
export const internalApiClient = axios.create({
  baseURL: config.internalApiUrl,
  headers: {
    "Content-Type": "application/json",
    "X-API-KEY": config.apiKey,
  },
});
